import * as React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { LogoTextSvg } from 'assets/icons';
import PageFooter from 'components/Footer';
import Header from 'components/Header';
import Flex from 'components/common/Flex';
import Text from 'components/common/Text';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { AppTheme } from 'styles/theme';

interface TermsPageProps {}

const TermsPage = (props: TermsPageProps) => {
  const styles = useStyles(props);
  const history = useHistory();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Flex
      width="100vw"
      height={'100vh'}
      className={styles.pageContainer}
      bgcolor={'rgba(255, 255, 255)'}
      column
      centerY
    >
      <Flex position={'absolute'} top={0} left={0} width={'100%'}>
        <Header bgcolor={'rgba(255, 255, 255)'} />
      </Flex>

      <Flex width={'100%'} flex={1} column mb={mdDown ? 0 : 15} py={4} px={mdDown ? 6 : 2} maxWidth={1200}>
        {/* <Flex width={'100%'} justifyContent={'flex-end'}>
          <LogoTextSvg style={{ width: 120 }} />
        </Flex> */}

        <Text
          style={{
            fontWeight: 700,
            fontSize: 48,
            marginTop: 40
          }}
          color={`#E85130`}
        >
          Child Sexual Abuse and Exploitation (CSAE) Prevention Policy
        </Text>
        <Text color="#5F606D" my={0.5}>
          <strong style={{color:'#18181B'}}>Effective Date: </strong> February 28, 2025
        </Text>
        <Text color="#5F606D" my={0.5}>
          <strong style={{color:'#18181B'}}>Company: </strong> Pumpkin Global Limited
        </Text>
        <Text color="#5F606D" my={0.5}>
          <strong style={{color:'#18181B'}}>App Name: </strong> Pumpkin
        </Text>

        <Text component={'span'} color="#18181B" whiteSpace={'break-spaces'} mt={4} style={{ textAlign: 'justify' }}>
          <Text style={{ fontWeight: 'bold', fontSize: 18,marginBottom:10 }}>
            Introduction
          </Text>
          <p>{`Pumpkin is a voice livestreaming service designed to facilitate real-time discussions, education, and community engagement. We are committed to providing a safe, inclusive, and respectful environment for all users. As part of this commitment, we strictly prohibit any form of Child Sexual Abuse and Exploitation (CSAE) on our platform. This policy outlines our standards, procedures, and enforcement mechanisms to prevent and address CSAE-related content or behavior, in compliance with applicable laws.`}</p>
          <p>{`CSAE refers to any content or behavior that sexually exploits, abuses, or endangers children. This includes, but is not limited to, grooming a child for sexual exploitation, sextortion, trafficking of a child for sexual purposes, or any other form of sexual exploitation or abuse of minors.`}</p>
          <Text style={{ fontWeight: 'bold', fontSize: 18, marginTop:10, marginBottom:10 }}>
            Scope
          </Text>
          {`This policy applies to all users of Pumpkin, including hosts, participants, and listeners of voice livestreams, as well as any content shared or generated through the app. It covers all interactions within the platform, whether in real-time audio streams, recorded sessions (if applicable), or associated text-based communications.`}
          <Text style={{ fontWeight: 'bold', fontSize: 18, marginTop:10, marginBottom:10 }}>
            Zero-Tolerance Policy
          </Text>
          {`Pumpkin has a zero-tolerance stance toward CSAE. Any violation of this policy will result in immediate action, including account suspension or termination, removal of offending content, and reporting to relevant authorities as required by law.`}
          <Text style={{ fontWeight: 'bold', fontSize: 20, marginTop:20, marginBottom:20 }}>
            Prohibited Conduct and Content
          </Text>
          {`The following behaviors and content are strictly prohibited on Pumpkin:`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            1. Eligibility: 
          </Text>
          {`Engaging in conversations or actions intended to build trust with a minor for the purpose of sexual exploitation or abuse.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            2. Sextortion: 
          </Text>
          {`Coercing or blackmailing a minor into providing explicit content or engaging in sexual acts.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            3. Child Trafficking: 
          </Text>
          {`Promoting, facilitating, or discussing the trafficking of minors for sexual purposes or any other exploitative intent.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            4. Sexual Exploitation: 
          </Text>
          {`Sharing, soliciting, or discussing sexually explicit content involving minors, including images, audio, or descriptions.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            5. Endangerment: 
          </Text>
          {`Any behavior that puts a child at risk of sexual harm or exploitation, whether direct or indirect.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            6. CSAE Promotion:
          </Text>
          {`Advocating for, normalizing, or trivializing CSAE-related activities.`}


          <Text style={{ fontWeight: 'bold', fontSize:20, marginTop:20, marginBottom:20 }}>
            Prevention Measures
          </Text>
          {`To ensure a safe environment and prevent CSAE, Pumpkin implements the following safeguards:`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            1. Age Verification:
          </Text>
          {`EUsers must confirm they are at least 17 years old to use the app, in compliance with Google's policies. Additional age verification may be required for hosts or users engaging in sensitive discussions.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            2. Community Guidelines: 
          </Text>
          {`Our Community Guidelines explicitly prohibit CSAE and are presented to all users upon signup and accessible within the app at all times.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            3. Real-Time Monitoring: 
          </Text>
          {`We employ a combination of automated tools and human moderators to monitor livestreams for potential CSAE violations. Automated systems use AI to flag suspicious audio patterns or keywords, which are then reviewed by trained staff.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            4. User Reporting: 
          </Text>
          {`Users can report suspected CSAE activity directly within the app via a dedicated reporting feature. Reports are prioritized and reviewed within 24 hours.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            5. Content Retention: 
          </Text>
          {`Audio streams are temporarily stored for moderation purposes and deleted after 30 days, unless flagged for investigation.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            6. Education: 
          </Text>
          {` We provide resources and reminders to users about online safety and the importance of protecting minors.`}

          <Text style={{ fontWeight: 'bold', fontSize: 20, marginTop:20, marginBottom:20 }}>
            Enforcement Actions
          </Text>
          {`Upon detection or reporting of CSAE-related violations, Pumpkin will take the following steps:`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            1. Immediate Suspension: 
          </Text>
          {`Accounts involved in CSAE activity will be temporarily suspended pending investigation.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            2. Content Removal: 
          </Text>
          {`Any offending audio streams or related content will be immediately removed from the platform.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            3. Investigation:
          </Text>
          {`Our moderation team will conduct a thorough review of the reported incident, including analysis of audio logs and user activity.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            4. Account Termination:  
          </Text>
          {`Confirmed violations will result in permanent account bans.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            5. Legal Reporting: 
          </Text>
          {`We will report CSAE incidents to law enforcement or organizations such as the National Center for Missing and Exploited Children (NCMEC) as required by law.`}
          <Text style={{ fontWeight: 'bold', fontSize: 16, marginTop:5, marginBottom:5 }}>
            6. CSAE Promotion:
          </Text>
          {`Advocating for, normalizing, or trivializing CSAE-related activities.`}


          <Text style={{ fontWeight: 'bold', fontSize: 18, marginTop:10, marginBottom:10 }}>
            User Responsibilities
          </Text>
          {`All users are expected to:`}
          <ul>
            <li>Refrain from engaging in or promoting CSAE-related activities.</li>
            <li>Report any suspected CSAE violations immediately using the in-app reporting tools.</li>
            <li>Adhere to our Community Guidelines and applicable laws regarding child safety.</li>
          </ul>
          <Text style={{ fontWeight: 'bold', fontSize: 18, marginTop:10, marginBottom:10 }}>
            Collaboration with Authorities
          </Text>
          {`Pumpkin is committed to cooperating fully with law enforcement and regulatory bodies to combat CSAE. We will provide relevant information, including user data and audio logs, when legally required to assist in investigations.`}

          <Text style={{ fontWeight: 'bold', fontSize: 18, marginTop:10, marginBottom:10 }}>
            Policy Updates
          </Text>
          {`This CSAE Prevention Policy may be updated periodically to reflect changes in legal requirements, platform features, or industry best practices. Users will be notified of significant updates via email or in-app notifications.`}

          <Text style={{ fontWeight: 'bold', fontSize: 18, marginTop:10, marginBottom:10 }}>
            Contact Us
          </Text>
          {`If you have questions about this policy or wish to report a concern, please contact our support team at support@pumpkin.xyz or through the in-app help center.`}
        </Text>
      </Flex>

      <Flex>
        <PageFooter isHome />
      </Flex>
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    pageContainer: {
      overflowX: 'hidden',
      overflowY: 'auto'
    },
    sessionWrap: {
      width: '100%'
    },
    footerWrap: {
      width: '100%'
    }
  })
);

export default observer(TermsPage);
